<template>
    <ListEditForm
        :form-component="AchievementForm"
        :new-item-generator="newAchievement"
        new-item-label="Pridať úspech"
        :value="modelValue"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event)"
    />
</template>

<script setup lang="ts">
import { Achievement, defaultAchievement } from '#shared/types/User'
import AchievementForm from '@/components/profile/AchievementForm.vue'
import ListEditForm from '@/components/profile/ListEditForm.vue'

defineProps<{
    modelValue: Achievement[]
}>()

defineEmits<{
    'update:modelValue': [value: Achievement[]]
}>()

const newAchievement = () => ({ ...defaultAchievement })
</script>